import React, { Component } from 'react';
import MainPage from './pages/MainPage'
class App extends Component {
  render() {
    return <MainPage />

   
    
  }
}

export default App;
